import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination } from 'swiper/modules';
import './style/section6.css'

const Section6 = () => {

    const testimonials = [
        {
            name: 'Tania Andrew',
            review: 'I truly believe that philanthropy and commerce can work together.',
            rating: 5,
            image: 'https://images.unsplash.com/photo-1633332755192-727a05c4013d?ixlib=rb-1.2.1&amp;ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&amp;auto=format&amp;fit=crop&amp;w=1480&amp;q=80',
            productImage: 'https://ik.imagekit.io/saufrbirqu/e4_bUyGC84jt.jpg',
            productName: 'Perl Earring'
        },
        {
            name: 'Staller',
            review: 'I truly believe that philanthropy and commerce can work together.',
            rating: 5,
            image: 'https://images.pexels.com/photos/2387335/pexels-photo-2387335.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load',
            productImage: 'https://ik.imagekit.io/saufrbirqu/3a_pWef78_fKz.jpg?updatedAt=1716813814268',
            productName: 'Nose pin'
        },
        {
            name: 'Greav',
            review: 'I truly believe that philanthropy and commerce can work together.',
            rating: 5,
            image: 'https://images.pexels.com/photos/952611/pexels-photo-952611.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load',
            productImage: 'https://ik.imagekit.io/saufrbirqu/1c_847t0R9sN.webp?updatedAt=1716817561995',
            productName: 'Bracelet'
        },
        {
            name: 'John Shah',
            review: 'I truly believe that philanthropy and commerce can work together.',
            rating: 5,
            image: 'https://images.pexels.com/photos/3492105/pexels-photo-3492105.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load',
            productImage: 'https://ik.imagekit.io/saufrbirqu/Earring4_aU2w6feiD.jpg?updatedAt=1716814813330',
            productName: 'Earring'
        },
        {
            name: 'Vysam',
            review: 'I truly believe that philanthropy and commerce can work together.',
            rating: 5,
            image: 'https://images.pexels.com/photos/1853099/pexels-photo-1853099.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load',
            productImage: 'https://ik.imagekit.io/saufrbirqu/r3_gzCDGOSVt.jpg',
            productName: 'Diamond Ring'
        },
        {
            name: 'Rubina Huva',
            review: 'I truly believe that philanthropy and commerce can work together.',
            rating: 5,
            image: 'https://images.pexels.com/photos/2918545/pexels-photo-2918545.jpeg?auto=compress&cs=tinysrgb&w=600&lazy=load',
            productImage: 'https://ik.imagekit.io/saufrbirqu/c3_bqTKr9hx4.jpg',
            productName: 'Chain'
        },
    ];
   
      
    
    return (
        <div className='py-20 px-10 bg-gray-200 about-section-6'>
        <div className=' text-center mb-10'>
            <p className='font-semibold text-2xl'>Customer Reviews</p>
            <p className='font-semibold text-gray-800'>Our references: A few of the thousands of happy customer reviews.</p>
        </div>
        <Swiper
          slidesPerView={1}
          spaceBetween={10}
          breakpoints={{
            
            640: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
            1920:{
                slidesPerView: 5,
                spaceBetween: 20,

            }
          }}
          modules={[Pagination]}
          className='mySwiper'
        >
            {testimonials.map((testimonial, index) => (
                <SwiperSlide key={index}>
                <div key={index} className="relative flex w-full max-w-[26rem] flex-col bg-transparent bg-clip-border text-gray-700 shadow-none p-5 rounded-none" >
                    <div className="relative flex items-center gap-4 pt-0 pb-8 mx-0 mt-4 overflow-hidden text-gray-700 bg-transparent shadow-none rounded-xl bg-clip-border">
                        <img src={testimonial.image} alt={testimonial.name} className="relative inline-block h-[58px] w-[58px] !rounded-full object-cover object-center" />
                        <div className="flex w-full flex-col gap-0.5">
                            <div className="flex items-center justify-between">
                                <h5 className="block font-sans text-xl antialiased font-semibold leading-snug tracking-normal text-blue-gray-900">{testimonial.name}</h5>
                            </div>
                            <p className="block font-sans text-base antialiased font-light leading-relaxed text-blue-gray-900 text-start">Review</p>
                        </div>
                    </div>
                    <div>
                        <div className="flex items-center justify-center my-5">
                            {[...Array(testimonial.rating)].map((_, i) => (
                                <svg key={i} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5 text-yellow-700">
                                    <path fillRule="evenodd" d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.007 5.404.433c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.433 2.082-5.006z" clipRule="evenodd"></path>
                                </svg>
                            ))}
                        </div>
                    </div>
                    <div className="p-0 mb-6">
                        <p className="block font-sans text-base antialiased font-light leading-relaxed text-inherit text-center">{testimonial.review}</p>
                    </div>
                    <div className="flex">
                        <img src={testimonial.productImage} alt="" className="rounded-full h-14 w-14" />
                        <p className="ms-5 mt-3">{testimonial.productName}</p>
                    </div>
                </div>
                </SwiperSlide>
            ))}
        </Swiper>
    </div>
    )
}

export default Section6
